import { Button, Typography, ButtonProps } from '@mui/material';
import { memo, MouseEventHandler } from 'react';

interface IPositiveButtonprops extends ButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  title: string;
}

function PositiveButton(props: IPositiveButtonprops) {
  const { onClick, title, ...others } = props;
  return (
    <Button variant="contained" color="primary" onClick={onClick} {...others}>
      <Typography sx={{ typography: 's14w500' }}>{title}</Typography>
    </Button>
  );
}

export default memo(PositiveButton);
